<template>
	<page-container class="container container-menu no-heading-image" :page="page">
		<div v-if="page.headingImages">
			<heading-image
				v-for="(item, index) in page.headingImages"
				:key="index"
				:heading-image="item"
				type="fixed"
				:title="page.title || page.header"
			/>
		</div>

		<section class="menus">
			<nuxt-link
				v-for="(menu, index) in menus"
				:key="index"
				:to="menu.menuFile"
				target="_blank"
				class="menu-item"
			>
				<h2>{{ menu.header }}</h2>
			</nuxt-link>
		</section>

		<frequently-asked-questions
			v-if="page.frequentlyAskedQuestion"
			:header="page.frequentlyAskedQuestion.header"
			:subtitle="page.frequentlyAskedQuestion.subtitle"
			:items="page.frequentlyAskedQuestion.faqitems"
		/>
	</page-container>
</template>

<script setup>
const { page, fetchPage } = usePage();
const { locale } = useI18n();

await fetchPage();

const { data: menus } = await useWebsiteFetch('menus', {
	query: { language: locale.value },
	key: `${locale.value}/menus`,
});

useHead({
	bodyAttrs: {
		class: 'menu',
	},
});
</script>

<style lang="scss" scoped>
.close-button {
	position: absolute;
	top: 50px;
	right: 50px;
	left: auto;
	bottom: auto;
	font-size: 40px;
	z-index: 4;
}

.menus {
	position: relative;
	z-index: 2;
	display: flex;
	flex-flow: row wrap;
	justify-content: space-between;
	align-items: center;
	padding: 380px 240px 100px;
	max-width: 1620px;
	margin: 0 auto;

	.menu-item {
		text-align: center;
		max-width: 270px;
		outline: none;
		cursor: pointer;
		text-decoration: none;
		position: relative;

		// background: url('~/assets/images/menu-items-bg-image-1.png') center center no-repeat;
		// background-size: contain;

		h2 {
			color: var(--primary-background-color);
			font-size: 60px;
			font-weight: 500;
			padding: 50px 20px;
			word-spacing: 100%;
			position: relative;
			z-index: 2;

			&::after {
				float: left;
				content: '';
				width: 70px;
				height: 15px;
				margin: 0;
			}
		}

		&:nth-child(2) {
			// background: url('~/assets/images/menu-items-bg-image-2.png') center center no-repeat;
			// background-size: contain;

			h2 {
				&::before {
					float: left;
					content: '';
					width: 20px;
					height: 15px;
					margin: 0;
				}

				&::after {
					display: none;
				}
			}
		}

		// &:last-child {
		// 	background: url('~/assets/images/menu-items-bg-image-3.png') center center no-repeat;
		// 	background-size: contain;
		// }
	}
}

.row {
	max-width: 1400px;
}

@media (max-width: 1280px) {
	.menus {
		padding-top: 300px;
	}
}

@media (max-width: 1080px) {
	.menus {
		padding: 10px 20px;
		min-height: 100vh;
		flex-flow: column wrap;
		justify-content: center;
		gap: 10px;
		text-align: center;

		.menu-item {
			text-align: center;
			max-width: 96%;

			h2 {
				padding: 30px 10px;
				font-size: 50px;
				word-spacing: unset;
				text-align: center;

				&::after,
				&::before {
					display: none;
				}
			}
		}
	}
}

@media (max-width: 900px) {
	.menus {
		min-height: 115vh;
	}
}
</style>
